"use strict";

var _xmlFeed = require("./components/xml-feed");

/* ----------------------------------------------------------------
Import Components Modules
---------------------------------------------------------------- */

/* ----------------------------------------------------------------
Initialse the document
---------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  // The container element / page
  var page = document.querySelector('.xml-feed') || false; // If the page doesnt exist then stop everything

  if (page === false) return; // A set of timeouts

  var timeouts = {}; // Find the filter elements

  var filters = page.querySelectorAll('.xml-feed__filters input, .xml-feed__filters select, .xml-feed__filters textarea'); // Where the XML Feed content will be loaded

  var content = page.querySelector('.xml-feed__list'); // Set a window variable to access from other files

  window.XMLFeed = new _xmlFeed.XMLFeed(page.getAttribute('data-api')); // An on change event for the input filters

  var onChange = function onChange(input) {
    clearTimeout(timeouts['onChange']);
    timeouts['onChange'] = setTimeout(function () {
      // If there is a value, add it to the filer values, otherwise remove it
      input.value === '' ? window.XMLFeed.remove(input.name) : window.XMLFeed.set(input.name, input.value); // Apply the filter

      window.XMLFeed.filter();
    }, 500);
  }; // Add the event listener to the filters

  var _loop = function _loop(index) {
    var input = filters[index]; // Set any preselected values

    if (input.type == 'checkbox' || input.type == 'radio' && input.checked) onChange(input);
    if (input.type == 'text' || input.type == 'textarea' && input.value) onChange(input);
    if (input.type == 'select-one' && input.selectedIndex > 0) onChange(input); // When the input value is changed, set the filter value

    input.addEventListener('input', function () {
      return onChange(input);
    });
  };
  for (var index = 0; index < filters.length; index++) {
    _loop(index);
  } // When the feed is filtered

  window.XMLFeed.on('filter', function (response) {
    return content.innerHTML = response;
  });
});